import React from 'react';
import { makeStyles } from '@material-ui/core';
//import ErrorIcon from '@material-ui/icons/Error';
//import InfoIcon from '@material-ui/icons/Info';
import { oprolsysteem, bedrukken, coronabehandeling, microperforatie, rillijnen, snijlijnen } from '../../Config/constants'

export default function BOLImagesComponent(props) {
    const classes = useStyles();

    let imageSources = []
    var i;
    for (i = 0; i < props.bolMetaData.length; i++) {
        switch (props.bolMetaData[i].Name) {
            case bedrukken:
                imageSources[i] = [];
                imageSources[i].push(process.env.PUBLIC_URL + '/img/afdrukken.svg');
                break;
            case microperforatie:
                imageSources[i] = [];
                imageSources[i].push(process.env.PUBLIC_URL + '/img/microperforatie.svg');
                break;
            case coronabehandeling:
                imageSources[i] = [];
                imageSources[i].push(process.env.PUBLIC_URL + '/img/coronabehandeling.svg');
                break;
            case snijlijnen:
                imageSources[i] = [];
                imageSources[i].push(process.env.PUBLIC_URL + '/img/snijlijnen.svg');
                break;
            case oprolsysteem:
                imageSources[i] = [];
                imageSources[i].push(process.env.PUBLIC_URL + '/img/oprollen.svg');
                break;
            case rillijnen:
                imageSources[i] = [];
                imageSources[i].push(process.env.PUBLIC_URL + '/img/rillijnen.svg');
                break;
            default:
        }
    }

    return (
        <div className={classes.container}>
            {imageSources.map((x, index) => <img className={classes.img} alt={x} src={x} key={index}></img>)}
        </div>
    )

}

const useStyles = makeStyles(() => ({
    container: {

    },
    img:{
        float:"right",
        height:"45px",
        marginLeft:"10px"
    }
}));